// extracted by mini-css-extract-plugin
module.exports = {"backInStockBtn":"back-in-stock-button_component_backInStockBtn__3XN5T","loading":"back-in-stock-button_component_loading__csLZ2"};